import { generateDocRef } from "modules/firebase";
import { LOCK_TABLE } from "services/firebaseService/storagePaths";

export const createLockTablesRef = generateDocRef(
  (eventId: string, floorId: string) =>
    `Event/${eventId}/${LOCK_TABLE}/${floorId}`,
);
